export const adminUsersQueryKey = () => ["adminUsers"] as const;
